"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionalParameterRevision = exports.RegionalPlan = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
exports.RegionalPlan = iotv_v3_types_1.RFRegions;
var RegionalParameterRevision;
(function (RegionalParameterRevision) {
    RegionalParameterRevision["LoRaWAN\u00AE v1.0.1"] = "LoRaWAN\u00AE v1.0.1";
    RegionalParameterRevision["Regional Parameters v1.0.2rB"] = "Regional Parameters v1.0.2rB";
    RegionalParameterRevision["Regional Parameters v1.0.3rA"] = "Regional Parameters v1.0.3rA";
    RegionalParameterRevision["Regional Parameters v1.1rA"] = "Regional Parameters v1.1rA";
    RegionalParameterRevision["RP002-1.0.0"] = "RP002-1.0.0";
    RegionalParameterRevision["RP002-1.0.1"] = "RP002-1.0.1";
    RegionalParameterRevision["RP002-1.0.2"] = "RP002-1.0.2";
    RegionalParameterRevision["RP002-1.0.3"] = "RP002-1.0.3";
})(RegionalParameterRevision || (exports.RegionalParameterRevision = RegionalParameterRevision = {}));
